export const ENV = {
  BASE_DOMAIN: '/',
};
